export function ControlledSearchBox({
  inputRef,
  isSearchStalled,
  onChange,
  onReset,
  onSubmit,
  placeholder,
  value,
  ...props
}) {
  return (
    <li className="">
      <div className="" {...props}>
        {/* <form className="inner_searchbar'"> */}
        <input
          ref={inputRef}
          className="input-control small"
          autoComplete="off"
          autoCorrect="off"
          autoCapitalize="off"
          placeholder={placeholder}
          spellCheck={false}
          maxLength={512}
          type="search"
          value={value}
          onChange={onChange}
        />
        {/* </form> */}
      </div>
    </li>
  );
}
